export const name = 'viewerManagerRuntimeApi' as const
export const RuntimeApiSymbol = Symbol('RuntimeApi')
